

import { Modal, Button, Form } from "react-bootstrap";
import { CgCheckO, CgCloseO } from 'react-icons/cg'


export default function ModalConfermaConsensoPrivacy(props) {

    const handleClose = () => {
        props.setMostra(false)
    };

    const handleConferma = () => {
        props.azioneConferma()
    }

    return (
        <Modal
            show={props.mostra}
            onHide={handleClose}
            centered
            backdrop={props.mode === "success" ? "static" : "true"}
        >
            <Modal.Header>
                <Modal.Title className="w-100 text-center">
                    {props.mode === 'danger' || props.mode === 'error' ?
                        <CgCloseO className="me-2 text-danger" />
                        :
                        <CgCheckO className="me-2 text-success" />
                    }
                    {props.titolo}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={props.bodyAlign}>
                {props.messaggio}
            </Modal.Body>
            <Form.Group className="mb-4 ml-4 p-4">
                <Form.Label>
                    <strong>Autorizzazione al consenso sulla privacy *</strong>
                </Form.Label>
                <Form.Check
                    type="checkbox"
                    id="checkbox"
                    required
                    label={
                        <>
                            <span className="italic d-block">Acconsento al trattamento dei miei dati personali:&nbsp;
                                <a href={props.comune.comLinkPrivacy}>
                                    Informativa resa ai sensi dell'art. 13 del RGPD 2016/679
                                </a>
                                &nbsp;(Regolamento Generale Protezione Dati)
                            </span>
                        </>
                    }
                    checked={props.consensoPrivacy}
                    onChange={(ev) => {
                        props.setConsensoPrivacy(ev.target.checked);
                    }}
                />
            </Form.Group>

            <Modal.Footer className={props.mode !== "success" && props.mode !== "error" ? "d-flex justify-content-between" : "d-flex justify-content-center"}>
                {
                    props.mode !== "success" &&
                    props.mode !== "error" &&
                    <Button variant="outline-secondary"
                        onClick={() => {
                            handleClose()
                            props.azioneAnnulla &&
                                props.azioneAnnulla()
                        }}>
                        {props.btnAnnulla}
                    </Button>
                }
                {
                    props.btnConferma &&
                    <Button variant="primary" onClick={handleConferma} disabled={!props.consensoPrivacy}>{props.btnConferma}</Button>
                }
            </Modal.Footer>
        </Modal >
    )
}






























